import React from "react";

const SkipEmployee = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path
            className="u_fill"
            d="M2.621 28.449a1.193 1.193 0 001.253-.107c.066-.054 7.127-5.205 13.55 0a13.633 13.633 0 007.891 2.435 15.555 15.555 0 008.088-2.388A1.194 1.194 0 0034 27.363v-18.6a1.194 1.194 0 00-1.79-1.026c-7.408 4.447-13.055.256-13.27.095-7.831-6.327-16.373-.09-16.462 0A1.194 1.194 0 002 8.793v18.588a1.194 1.194 0 00.621 1.068z"
            fill={fill}
        />
        <path
            d="M10.683 18.645A1.79 1.79 0 019 17.63l-2.054 1.194a4.59 4.59 0 002.22 1.958v.99h2.388v-.859c1.117-.346 2.227-1.26 2.388-2.507.173-1.54-.55-2.584-2.13-3.11-.466-.155-.86-.268-1.195-.364-.883-.25-.979-.304-1.098-.49a.418.418 0 01-.06-.334.597.597 0 01.257-.376c.26-.112.551-.123.818-.03a1.852 1.852 0 011.158.896l2.125-1.086a4.178 4.178 0 00-2.263-2.006v-1.003H9.167v.86c-.282.077-.55.198-.794.358a2.984 2.984 0 00-1.277 1.898 2.794 2.794 0 00.411 2.131c.633.943 1.469 1.194 2.436 1.456.31.09.668.191 1.092.329.555.185.55.215.508.597a1.194 1.194 0 01-.86.513zM30.229 19.06a.81.81 0 00-.302-.632l-5.212-4.243a.814.814 0 00-1.328.632v8.488a.812.812 0 001.328.631l5.21-4.24a.812.812 0 00.304-.635zM21.064 13.838h-1.162V24.29h1.162V13.838z"
            fill="#fff"
        />
    </svg>
);

export default SkipEmployee;